import Main from './common/main';

window.addEventListener('unload', () => {});
window.addEventListener('pageshow', evt => {
  if (evt.persisted) location.reload();
});


const main = new Main();